module.exports = __webpack_public_path__ + "static/media/piggy.29223e1a.svg";